import { AnyAction } from 'redux'

import { ISubscription } from 'models/subscriptions.model'

import { PaymentMethod } from 'modules/payment/constants'
import {
  SET_IS_FIRST_PAYMENT_RETRY_PASSED,
  SET_IS_PRIMER_RETRY_PROCESSING,
  SET_PRIMER_CLIENT_SESSION_TOKEN,
} from 'modules/payment/redux/actions/primer'

import { PlanAddition } from 'root-constants/common'

import {
  RESET_3D_SECURE_IFRAME_URL,
  SET_3D_SECURE_IFRAME_URL,
  SET_CPF,
  SET_IS_BOLETO_VOUCHER_CLOSED,
  SET_IS_PAYMENT_COMPLETED,
  SET_IS_PAYMENT_FLOWS_SHOWN,
  SET_PAYMENT_CLIENT_SECRET,
  SET_PAYMENT_METHOD,
  SET_PAYMENT_REQUEST_BUTTON_TYPE,
  SET_PLAN_ADDITIONS,
  SET_SUBSCRIPTION,
  SET_SUBSCRIPTION_ID,
} from './actions/common'

export interface IPaymentState {
  selectedSubscription: ISubscription | null
  threeDSecureIframeURL: string
  paymentClientSecret: string
  subscriptionId: string
  cpf: string
  isPaymentFlowsShown: boolean
  planAdditions: PlanAddition[]
  paymentMethod: PaymentMethod
  paymentRequestButtonType: PaymentMethod | null
  primerClientSessionToken: string
  isFirstPaymentRetryPassed: boolean
  isPrimerRetryProcessing: boolean
  isPaymentCompleted: boolean
  isBoletoVoucherClosed: boolean
}

const initState: IPaymentState = {
  selectedSubscription: null,
  threeDSecureIframeURL: '',
  paymentClientSecret: '',
  subscriptionId: '',
  cpf: '',
  isPaymentFlowsShown: false,
  planAdditions: [],
  paymentMethod: PaymentMethod.CREDIT_CARD,
  paymentRequestButtonType: null,
  primerClientSessionToken: '',
  isFirstPaymentRetryPassed: false,
  isPrimerRetryProcessing: false,
  isPaymentCompleted: false,
  isBoletoVoucherClosed: false,
}

export function paymentReducer(
  state: IPaymentState = initState,
  { type, payload = null }: AnyAction,
): IPaymentState {
  switch (type) {
    case SET_SUBSCRIPTION: {
      return {
        ...state,
        selectedSubscription: payload,
      }
    }
    case SET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        threeDSecureIframeURL: payload,
      }
    }
    case RESET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        threeDSecureIframeURL: '',
      }
    }
    case SET_PAYMENT_CLIENT_SECRET: {
      return {
        ...state,
        paymentClientSecret: payload,
      }
    }
    case SET_SUBSCRIPTION_ID: {
      return {
        ...state,
        subscriptionId: payload,
      }
    }
    case SET_CPF: {
      return {
        ...state,
        cpf: payload,
      }
    }
    case SET_IS_PAYMENT_FLOWS_SHOWN: {
      return {
        ...state,
        isPaymentFlowsShown: payload,
      }
    }
    case SET_PLAN_ADDITIONS: {
      return {
        ...state,
        planAdditions: payload,
      }
    }
    case SET_PAYMENT_METHOD: {
      return {
        ...state,
        paymentMethod: payload,
      }
    }
    case SET_PAYMENT_REQUEST_BUTTON_TYPE: {
      return {
        ...state,
        paymentRequestButtonType: payload,
      }
    }
    case SET_PRIMER_CLIENT_SESSION_TOKEN: {
      return {
        ...state,
        primerClientSessionToken: payload,
      }
    }
    case SET_IS_FIRST_PAYMENT_RETRY_PASSED: {
      return {
        ...state,
        isFirstPaymentRetryPassed: payload,
      }
    }
    case SET_IS_PRIMER_RETRY_PROCESSING: {
      return {
        ...state,
        isPrimerRetryProcessing: payload,
      }
    }
    case SET_IS_PAYMENT_COMPLETED: {
      return {
        ...state,
        isPaymentCompleted: payload,
      }
    }
    case SET_IS_BOLETO_VOUCHER_CLOSED: {
      return {
        ...state,
        isBoletoVoucherClosed: payload,
      }
    }
    default:
      return state
  }
}
